
    import './styles.scoped.css';
    export default {
  "tutorial-panel": "awsui_tutorial-panel_1oin5_180f1_93"
};
  